export default __webpack_public_path__ + "static/media/linea-blanca.72c34b06.svg";